<template>
    <div class="pp-main">
        <slot></slot>
    </div>
</template>

<script>
/**
 * 内容栏
 * @desc 与<pp-header fixed>同级使用时会产生margin-top
 */
export default {
    name: 'pp-main',
}
</script>

<style>

</style>
